import { Button, Tooltip } from '@arco-design/web-react'
import styles from './index.module.less'
import { IconList as ArcoIconList, IconApps } from '@arco-design/web-react/icon'
import cx from 'classnames'
import { useToggle, useMount } from 'ahooks'
import useLocale from '@/utils/useLocale'

const ButtonGroup = Button.Group

interface Prop {
  defaultIsTable?: boolean
  onChange: (val: boolean) => void
}
const TypeSettingSwitch = ({ defaultIsTable, onChange }: Prop) => {
  const [curIsTable, { set }] = useToggle(false)
  const t = useLocale()

  useMount(() => {
    if (typeof defaultIsTable === 'boolean') {
      set(defaultIsTable)
    }
  })

  return (
    <div className={styles['select-types']}>
      <ButtonGroup>
        <Tooltip content={t['cover_mode']}>
          <Button
            type="outline"
            shape="round"
            style={{ width: 36 }}
            onClick={() => {
              onChange(false)
              set(false)
            }}
            icon={<IconApps />}
            className={cx({ [`${styles.typeSelected}`]: !curIsTable })}
          ></Button>
        </Tooltip>
        <Tooltip content={t['table_mode']}>
          <Button
            onClick={() => {
              onChange(true)
              set(true)
            }}
            icon={<ArcoIconList />}
            shape="round"
            type="outline"
            className={cx({ [`${styles.typeSelected}`]: curIsTable })}
            style={{ width: 36 }}
          ></Button>
        </Tooltip>
      </ButtonGroup>
    </div>
  )
}

export default TypeSettingSwitch
